"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.thClassName = exports.theadClassName = exports.THead = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var core_1 = require("@newfront-insurance/core");
var core_ui_1 = require("@newfront-insurance/core-ui");
var kebabCase_1 = __importDefault(require("lodash/kebabCase"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var row_1 = require("./row");
var sort_icon_1 = require("./sort-icon");
function THead(_a) {
    var headerGroups = _a.headerGroups, onSort = _a.onSort, _b = _a.borderTop, borderTop = _b === void 0 ? true : _b, testId = _a.testId, props = __rest(_a, ["headerGroups", "onSort", "borderTop", "testId"]);
    function handleSort(column) {
        if (!onSort) {
            return;
        }
        if (column.isSortedDesc) {
            onSort();
            return;
        }
        onSort({
            id: column.id,
            desc: !!column.isSorted,
        });
    }
    var borderTopStyle = typeof borderTop === 'boolean' && !borderTop && { borderTop: 'none' };
    return (react_1.default.createElement(StyledTHead, __assign({ className: exports.theadClassName }, props, { "data-testid": (0, core_ui_1.generateTestId)(testId, 'thead') }), headerGroups.map(function (headerGroup) { return (react_1.default.createElement(row_1.Row, __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
        var _a, _b, _c;
        var columnProps = column.getHeaderProps();
        var title = (_a = column.title) !== null && _a !== void 0 ? _a : (typeof column.render('Header') === 'string' ? (_b = column.render('Header')) === null || _b === void 0 ? void 0 : _b.toString() : undefined);
        var columnTestId = (_c = column.testId) !== null && _c !== void 0 ? _c : ((0, core_1.isNotUndefined)(title) ? (0, core_ui_1.generateTestId)(testId, "header-".concat((0, kebabCase_1.default)(title))) : undefined);
        return (react_1.default.createElement(StyledTH, __assign({}, columnProps, { style: __assign(__assign(__assign({}, columnProps.style), borderTopStyle), (column.sticky && { position: 'sticky' })), title: title, className: exports.thClassName, isSorted: column.isSorted, sticky: column.sticky, "data-testid": columnTestId, onClick: column.canSort ? function () { return handleSort(column); } : undefined }),
            !column.disableResizing && (react_1.default.createElement("div", __assign({}, (column.getResizerProps ? column.getResizerProps() : {}), { className: "resizer ".concat(column.isResizing ? 'isResizing' : ''), "data-testid": (0, core_ui_1.generateTestId)(columnTestId, 'resizer') }))),
            react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center" },
                column.id === 'selection' ? (column.render('Header')) : (react_1.default.createElement(core_ui_1.LineClamp, { numOfLines: 1 },
                    react_1.default.createElement("div", __assign({}, (column.getSortByToggleProps
                        ? column.getSortByToggleProps((0, core_1.filterUndefinedProps)({
                            onClick: onSort && column.canSort ? function () { return handleSort(column); } : undefined,
                            title: title,
                        }))
                        : {}), { "data-testid": (0, core_ui_1.generateTestId)(columnTestId, 'text') }), column.render('Header')))),
                !column.disableSortBy && (react_1.default.createElement(sort_icon_1.Sort, { direction: !column.isSorted || column.isSortedDesc ? 'desc' : 'asc', active: column.isSorted })))));
    }))); })));
}
exports.THead = THead;
var StyledTHead = styled_components_1.default.div({
    position: 'sticky',
    top: 0,
    zIndex: 3,
});
exports.theadClassName = "newfront-spreadsheet--thead";
exports.thClassName = "newfront-spreadsheet--th";
var StyledTH = styled_components_1.default.div(function (_a) {
    var isSorted = _a.isSorted, sticky = _a.sticky;
    return ({
        height: 48,
        top: 0,
        borderTop: "1px solid ".concat(core_ui_1.colors.border.default),
        boxSizing: 'border-box',
        padding: '12px 8px',
        textAlign: 'left',
        fontWeight: 600,
        fontFamily: core_ui_1.fontFamilies.body,
        fontSize: core_ui_1.fontSizes.regular.fontSize,
        lineHeight: core_ui_1.fontSizes.regular.lineHeight,
        color: isSorted ? core_ui_1.colors.steel[500] : core_ui_1.colors.steel[400],
        userSelect: 'none',
        backgroundColor: '#fff',
        right: sticky === 'right' ? 0 : 'auto',
    });
});
